import {
  ADD_SCHOOLS_MODEL,
  ADD_UNIVERSITY_MODEL,
  ADMIN_ROLES_MODEL,
  API_RESPONSE_MODEL,
  AUTHENTICATION_LABELS_MODEL,
  DASHBOARD_MODEL,
  I18_TRANSLATION_COMMON_MODEL,
  LANGUAGES_MODEL,
  LAYOUTS_MODEL,
  LOGIN_FIELDS_MODEL,
  REGISTRATION_MODEL,
  ROUTES_MODEL,
  SIDEBAR_MODEL,
  TOKENS_MODEL,
} from "../Models/ConstantModels";
import {
  StepConnector,
  StepIconProps,
  stepConnectorClasses,
  styled,
} from "@mui/material";
import RoundIcon from "../../../Assets/Registration/Active_stepper_icon.svg";
import InactiveIcon from "../../../Assets/Registration/Inactive_stepper_icon.svg";
//sidebar icons
import dashboard from "../../../Assets/sidebar/dashboard.svg";
import schools from "../../../Assets/sidebar/schools.svg";
import university from "../../../Assets/sidebar/university.svg";
import dashboard_active from "../../../Assets/sidebar/dashboard_active.svg";
import schools_active from "../../../Assets/sidebar/school_active.svg";
import university_active from "../../../Assets/sidebar/university_active.svg";
import session from "../../../Assets/sidebar/session.svg";
import document from "../../../Assets/sidebar/manage_document_inactive.svg";
import document_active from "../../../Assets/sidebar/manage_document_active.svg";
import chat from "../../../Assets/sidebar/chat.svg";
import chat_recreational from "../../../Assets/sidebar/chat_recreational.svg";
import dashboard_recreational from "../../../Assets/sidebar/dashboard_recreational.svg";
import session_recreational from "../../../Assets/sidebar/session_recreational.svg";
import chat_tutor from "../../../Assets/sidebar/chat_tutor.svg";
import dashboard_tutor from "../../../Assets/sidebar/dashboard_tutor.svg";
import session_tutor from "../../../Assets/sidebar/sessions_tutor.svg";
import chat_school from "../../../Assets/sidebar/chat_school.svg";
import dashboard_school from "../../../Assets/sidebar/dashboard_school.svg";
import session_school from "../../../Assets/sidebar/session_school.svg";
import chat_university from "../../../Assets/sidebar/chat_university.svg";
import dashboard_university from "../../../Assets/sidebar/dashboard_university.svg";
import session_university from "../../../Assets/sidebar/sessions_university.svg";
import { GetSessionStorageData } from "../../Services/Helpers/Helper";

const DASHBOARD: DASHBOARD_MODEL = {
  REPORTS: "reports",
};
const ROUTES: ROUTES_MODEL = {
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  LOGIN_ERROR: "*",
  SIGN_UP: "/sign-up",
  OTP_VERIFICATION: "/otp-verification",
  RESET_PASSWORD: "/reset-password",
  FORGET_PASSWORD: "/forget-password",
  MANAGE_SCHOOLS: "/manage-schools",
  MANAGE_UNIVERSITIES: "/manage-universities",
  EDIT_UNIVERITY: "/manage-universities/:id",
  EDIT_SCHOOLS: "/manage-schools/:id",
  PROFILE: "/profile",
  TUTOR_REGISTRATION: "/tutor-registration",
  REGISTER_SP: "/register",
  MANAGE_SESSIONS: "/manage-sessions",
  CREATE_SESSIONS: "/manage-sessions/create-sessions",
  EDIT_SESSIONS: "/manage-sessions/edit/:id",
  VIEW_SESSIONS: "/manage-sessions/sessions/:id",
  MANAGE_BOOKINGS: "/manage-bookings",
  VIEW_BOOKINGS: "/manage-bookings/calender/:id",
  VIEW_BOOKINGS_LIST: "/manage-bookings/list/:id",
  ONBOARDING_SCREEN: "/onboarding",
  WELCOME_SCREEN: "/welcome",
  CALENDER_SESSION: "/create",
  NOTIFICATIONS: "/notification",
  CHAT: "/chat",
  MANAGE_DOCUMENTS: "/manage-documents",
  USER_CHAT: "/chat/:id",
  MANAGE_CANCELATIONS:"/manage-cancelations",
  MANAGE_DISCOUNTS:"/manage-discounts"
};
const TOKENS: TOKENS_MODEL = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  TEMPORARY_TOKEN: "temporaryToken"
};

const ADMIN_ROLES: ADMIN_ROLES_MODEL = {
  TUTOR: "4",
  RECREATIONAL_PERSONAL: "9",
  RECREATIONAL_CAMP: "5",
  SCHOOL: "6",
  UNIVERSITY: "7",
  EDUCATIONAL_EXPERT: "3"
};

const STORAGE_KEYS: any = {
  EMAIL: "email",
  MOBILE: "mobile",
  LOGIN_TYPE: "login_type",
  PHONE_NUMBER: "phone_number",
  MODE: "mode",
  ACTIVE_STEP: "activeStep",
  ROLE: "role",
  ID: "id",
  OTP_EXPIRED: "otp_exp",
  LANGUAGE: "language"
};

let roleId: any = GetSessionStorageData(STORAGE_KEYS.ROLE);

const getIcon = (type: any) => {
  if (type === 'dashboard') {
    if (roleId === ADMIN_ROLES.TUTOR) {
      return dashboard_tutor;
    } else if (roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL || ADMIN_ROLES.RECREATIONAL_CAMP) {
      return dashboard_recreational;
    } else if (roleId === ADMIN_ROLES.SCHOOL) {
      return dashboard_school
    } else if (roleId === ADMIN_ROLES.UNIVERSITY) {
      return dashboard_university
    }
  } else if (type === 'chat') {
    if (roleId === ADMIN_ROLES.TUTOR) {
      return chat_tutor;
    } else if (roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL || ADMIN_ROLES.RECREATIONAL_CAMP) {
      return chat_recreational;
    } else if (roleId === ADMIN_ROLES.SCHOOL) {
      return chat_school
    } else if (roleId === ADMIN_ROLES.UNIVERSITY) {
      return chat_university
    }
  }
}

const SIDEBAR: SIDEBAR_MODEL[] = [
  {
    ICON: dashboard,
    ACTIVE_ICON: getIcon('dashboard'),
    PATH: ROUTES.DASHBOARD,
    NAME: "Dashboard",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.TUTOR, ADMIN_ROLES.RECREATIONAL_PERSONAL, ADMIN_ROLES.RECREATIONAL_CAMP, ADMIN_ROLES.SCHOOL, ADMIN_ROLES.UNIVERSITY]
  },
  {
    ICON: schools,
    ACTIVE_ICON: schools_active,
    PATH: ROUTES.MANAGE_SCHOOLS,
    NAME: "Manage Schools",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.SCHOOL]
  },
  {
    ICON: university,
    ACTIVE_ICON: university_active,
    PATH: ROUTES.MANAGE_UNIVERSITIES,
    NAME: "Manage Universities",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.UNIVERSITY]
  },
  {
    ICON: session,
    ACTIVE_ICON: roleId === ADMIN_ROLES.TUTOR ? session_tutor : session_recreational,
    PATH: ROUTES.MANAGE_SESSIONS,
    NAME: "Create Sessions",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.TUTOR, ADMIN_ROLES.RECREATIONAL_PERSONAL, ADMIN_ROLES.RECREATIONAL_CAMP]
  },
  {
    ICON: session,
    ACTIVE_ICON: roleId === ADMIN_ROLES.TUTOR ? session_tutor : session_recreational,
    PATH: ROUTES.MANAGE_BOOKINGS,
    NAME: "View Bookings",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.TUTOR, ADMIN_ROLES.RECREATIONAL_PERSONAL, ADMIN_ROLES.RECREATIONAL_CAMP]
  },
  {
    ICON: document,
    ACTIVE_ICON: document_active,
    PATH: ROUTES.MANAGE_DOCUMENTS,
    NAME: "Manage Documents",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.TUTOR]
  },
  {
    ICON: document,
    ACTIVE_ICON: document_active,
    PATH: ROUTES.MANAGE_CANCELATIONS,
    NAME: "Manage Cancelations",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.TUTOR, ADMIN_ROLES.RECREATIONAL_PERSONAL]
  },
  {
    ICON: session,
    ACTIVE_ICON: session_recreational,
    PATH: ROUTES.MANAGE_DISCOUNTS,
    NAME: "Manage Discounts",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.RECREATIONAL_CAMP]
  },
  {
    ICON: chat,
    ACTIVE_ICON: getIcon('chat'),
    PATH: ROUTES.CHAT,
    NAME: "Manage Chats",
    SUB_MENU: [],
    ROLE: [ADMIN_ROLES.TUTOR, ADMIN_ROLES.RECREATIONAL_PERSONAL, ADMIN_ROLES.RECREATIONAL_CAMP]
  }
];

const TOASTER_CONFIGS: any = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};
const API_RESPONSE: API_RESPONSE_MODEL = {
  STATUS: "status",
  TRUE: true,
  FALSE: false,
  NULL: null,
  OK: "OK"
};
const LANGUAGES: LANGUAGES_MODEL = {
  ENGLISH: "English",
  ARABIC: "Arabic",
  ENGLISH_ABBRIVATION: "en",
  ARABIC_ABBRIVATION: "ar",
};
const AUTHENTICATION_LABELS: AUTHENTICATION_LABELS_MODEL = {
  LOGIN: "Login",
  SIGN_UP: "Sign Up",
  DONT_HAVE_ACCOUNT: "Don't have an account?",
  ALREADY_HAVE_AN_ACCOUNT: "Already have an account!",
};
const LOGIN_FIELDS: LOGIN_FIELDS_MODEL = {
  EMAIL: "email",
  PASSWORD: "password",
  REMEMBER_ME: "rememberMe",
};
const TUTOR_REGISTRATION_FIELDS: any = {
  TUTOR_TYPE: "tutorType",
  EMAIL: "email",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  MOBILE: "mobile",
  PASSWORD: "password",
  CONFIRM_PASSWORD: "confirmPassword",
};
const TUTOR_TYPE: any = [
  { value: "1", label: "Individual" },
  { value: "2", label: "Academy" },
];
const ADD_SCHOOLS: ADD_SCHOOLS_MODEL = {
  SCHOOL_NAME: "school_name",
  FOUNDED_YEAR: "founded_year",
  LOCATION: "address",
  CURRICULUM: "curriculam",
  SCHOOL_IMAGES: "images",
  WEBLINK_OF_SCHOOL: "web_link",
  EMAIL: "email",
  PHONE_NUMBER: "phone_number",
  PRINCIPAL: "principal",
  GRADE_YEAR: "gradeYear",
  TUITION_FEES: "tuitionFees",
  OPTIONAL_SERVICE_FEES: "optionalServiceFees",
  ENROLLMENT_FEES: "enrollmentFees",
  RE_ENROLLMENT_FEES: "reEnrollmentFees",
  APPLICATION_FEES: "applicationFees",
  TOTAL_FEES: "totalFees",
  DISCOUNT_ON_TUITION_FEES: "discountOnTuitionFees",
  START_OF_THE_ACADEMIC_YEAR: "academic_year_start",
  END_OF_THE_ACADEMIC_YEAR: "academic_year_end",
  WINTER_BREAK_START_DATE: "winter_break_start",
  WINTER_BREAK_END_DATE: "winter_break_end",
  SPRING_BREAK_START_DATE: "spring_break_start",
  SPRING_BREAK_END_DATE: "spring_break_end",
  SUMMER_BREAK_START_DATE: "summer_break_start",
  SUMMER_BREAK_END_DATE: "summer_break_end",
  OTHER_HOLIDAYS: "other_holidays",
  PUBLIC_HOLIDAYS: "public_holidays",
  DSIB_INSPECTION_REPORT: "dsib_inspection_report",
  DSIB_RATING: "dsip_rating",
  RATING: "rating",
  RANKING: "ranking",
};

const ADD_UNIVERSITY_FIELDS: ADD_UNIVERSITY_MODEL = {
  UNIVERSITY_NAME: "university_name",
  QUALITY_ASSURANCE: "quality_assurance",
  LOCATION: "address",
  UNIVERSITY_IMAGES: "images",
  WEBSITE_ADDRESS: "web_link",
  PRINCIPAL: "principal",
  EMAIL: "email",
  PHONE_NUMBER: "phone_number",
  DEGREES_AND_FEES: "degreesAndFees",
  PROGRAMS_OFFERED: "programs_offered",
  TEACHING_RATING: "teaching_rating",
  EMPLOYABILITY_RATING: "employability_rating",
  RESEARCH: "research",
  RATING: "rating",
  INTERNATIONALIZATION_RATING: "international_rating",
  FACILITIES_RATING: "facility_rating",
  PROGRAMME_STRENGTH_RATING: "programme_strength_rating",
  INCLUSIVENESS_RATING: "inclusiveness_rating",
  ENVIRONMENTAL: "environmental",
  IMPACT_RATING: "impact_rating",
  OVERALL_RATING: "overall_rating",
  NO_OF_STUDENTS: "students_count",
  TOTAL_GRADUATES: "total_graduates",
  NO_OF_EMIRATES: "emirates_count",
  STUDENTS: "student_percentage",
  NO_OF_EXPATS: "expats_percentage",
  MALE: "male",
  FEMALE: "female",
  TRANSGENDER: "transgender",
  TOTAL_EDUCATORS: "total_educators"
};

const REGISTRATION_FORM: REGISTRATION_MODEL = {
  FIRST_NAME: "firstname",
  FIRST_NAME_ARABIC: "arabic_firstname",
  LAST_NAME: "lastname",
  LAST_NAME_ARABIC: "arabic_lastname",
  EMAIL: "email",
  PHONE_NUMBER: "phone_number",
  PHONE: "phone",
  ROLES: "roles",
  ABOUT_ME: "about_me",
  DISCRIPTION: "description",
  GENDER: "gender",
  NATIONALITY: "nationality",
  ADDRESS: "address",
  CITY: "city",
  EMIRATE: "emirate",
  STATE: "state",
  PINCODE: "pincode",
  DOB: "dob",
  COUNTRY: "country",
  COUNTRY_CODE: "country_code",
  LATITUDE: "latitude",
  LONGITUDE: "longitude",
  CAMP_NAME: "campname",
  CAMP_NAME_ARABIC: "arabic_camp_name",
  ABOUT_CAMP: "about_camp",
  NAME: "name",
  AUTHORITY_NAME: "authority_name",
  AUTHORITY_EMAIL: "authority_email",
  CAMPSITE: "website_name"
};

const PROFESSIONAL_DETAILS: any = {
  DEGREE: "degree",
  SUBJECT: "subjects",
  CURRICULAM: "curriculum",
  TEACHING_MODE: "teaching_mode",
  EXPERIENCE: "experience",
  SKILLS: "skills",
  COURSES: "courses",
  TRAINER_QUALIFICATION: "trainer_qualification",
  ACTIVITIES_OFFERED: "activities_offered",
  SPECIALIZATIONS: "specializations",
  ONLINE: "online",
  OFFLINE: "offline",
  HIGHER_EDUCATION:"high_education",
  DEGREE_SUBJECT:"degree_subject",
  STATE:"state",
  RADIUS:"radius"
};

const PERSONAL_INFORMATION: any = {
  EMIRATES_ID: "emirates_id",
  IMMIGRANT_ID: "immigrant_id",
  EMIRATES_FRONT: "emirates_front",
  EMIRATES_BACK: "emirates_back",
  IMMIGRANT_FRONT: "immigrant_front",
  IMMIGRANT_BACK: "immigrant_back",
  PROFILE_IMAGE: "profile_image",
  CERTIFICATES: "certificates",
  CAMP_BROUCHER: "camp_broucher",
  TUTOR_CV: "tutor_cv",
  SELECT: "select",
  DROP: "drop",
  TRADE_ID: "trade_id",
  TRADE_LICENCE: "trade_license"
};

const BANKING_INFORMATION: any = {
  BANK_NAME: "bank_name",
  BANK_BRANCH_NAME: "bank_branch_name",
  ACCOUNT_HOLDER_NAME: "account_holder_name",
  ACCOUNT_NUMBER: "bank_ac_number",
  SWIFT_CODE: "bank_ac_swift_code",
  IBAN: "bank_iban_number"
}

const VALIDATION_CONSTANT: any = {
  COMMISSION: "commission",
  MAX_PRICE: "max_price",
  MIN_PRICE: "min_price",
  RECREATION: "recreation",
  COURSE: "course",
  VALID_NUMBER: "valid-number",
  VALID_COMMISSION: "valid-commission",
  KEY_TYPE: "Enter",
  PAGE: "page",
  TUTOR: "Tutor",
  CAMP: "Camp",
  PERSONAL: "Personal",
  TYPE_INFO: "type_info",
  RECREATIONAL_PERSONAL: "Recreational personal trainer",
  RECREATIONAL_CAMP: "Recreational camp"
};

const CREATE_SESSIONS_FIELD: any = {
  SESSION_NAME: "session_title",
  CATEGORY: "category",
  PRICE_PER_HOUR: "pricePerHour",
  SESSION_START_DATE: "sessionStartDate",
  SESSION_END_DATE: "sessionEndDate",
  SYLLABUS_FILE: "syllabusFile",
  ADDITIONAL_NOTES: "additional_notes",
  COURSE_TYPE: "course_type",
  SLOT_MODE: "slot_mode",
  TOTAL_DAYS: "total_days",
  DAILY: "daily",
  WEEKDAYS: "weekdays",
  WEEKENDS: "weekend",
  CUSTOM: "custom",
  MONTH: "month",
  MEET_LINK: "meet_link",
  GRADE: "grade",
  EQUIPMENTS: "equipments",
  BATCH_SIZE: "batch_size",
  DESCRIPTION: "description",
  CAMP_SESSION_TITLE: "camp_session_title",
  CAMP_SESSION_TITLE_ARABIC: "camp_session_title_arabic",
  GENDER: "gender",
  AMENITY: "amenities",
  AMENITY_ICON: "amenity_icon",
  AMENITY_NAME: "amenity_name",
  AGE_CATEGORY: "age_category",
  AGE_MIN: "min_age",
  AGE_MAX: "max_age",
};

const TOAST_ERRORS: any = {
  IMAGES_LIMIT: "Can upload only upto 10 Images",
  IMAGE_UPLOAD_ERROR: "Error uploading file:",
};

const SESSIONS_ERROR_MESSAGE: any = {
  SESSION_NAME_REQUIRED: "Please enter the session name",
  CATEGORY_REQUIRED: "Please select the category",
  PRICE_PER_HOUR_REQUIRED: "Please enter price per hour",
  SESSION_START_DATE_REQUIRED: "Please select the session start date",
  SESSION_END_DATE_REQUIRED: "Please select the session end date",
  SYLLABUS_FILE_REQUIRED: "Please upload a syllabus file",
  ADDITIONAL_NOTES_REQUIRED:
    "Please enter some addtional notes about the session",
  DATE_MISMATCH: "End date should be greater than start date",
  COURSE_TYPE_REQUIRED: "Please select the mode of teaching",
  DELETE_MESSAGE: "Are you sure want to delete this slot? Once deleted cannot be recovered.",
  SLOT_MODE: "Please select the repeat type",
  TOTAL_DAYS: "Please enter total days",
  GRADE_REQUIRED: "Please select the grade",
  EQUIPMENTS_NEEDED: "Please enter the equipments needed",
  BATCH_SIZE: "Please enter the batch size",
  DELETE_ALERT: "Are you sure want to close? Changes will not be saved.",
  SESSION_DELETE_ALERT_SINGLE:"This slot is booked by the user,Are you sure want to delete?",
  SESSION_DELETE_ALERT_MULTIPLE:"Followed event contains booked slots, Are you sure want to delete?",
  MEET_LINK:"Please enter the meet link"
};

const DIALOG_CONSTANT: any = {
  SCHOOL_INVITE: "Are you sure want to invite this school?",
  UNIVERSITY_INVITE: "Are you sure want to invite this university?",
  CANCEL_SLOT_TITLE :"Reason for cancelation",
  RESHEDULE_SLOT_TITLE : "Reason for Reshedule",
  ACTIVATE_DISCOUNT: "Are you sure want to activate this discount?",
  DEACTIVATE_DISCOUNT: "Are you sure want to deactivate this discount?",
  CANCEL_SLOT :"Are you sure want to cancel this slot?",
  RESHEDULE_SLOT : "Are you want to reshedule this slot"
}

const LAYOUTS: LAYOUTS_MODEL = {
  RTL: "rtl",
  LTR: "ltr",
};


const PAYLOAD_KEYS: any = {
  SERVICE_SESSION_ID: "service_session_id",
  TEACH_SERVICE_ID: "teach_service_id",
  SLOT_ID: "slot_id",
  TIMESLOT_ID: "timeslot_id"
}

const NOTIFICATION_CONSTANTS: any = {
  ONE_DAY: "1 day ago",
  ONE_HOUR: "1 hour ago",
  ONE_MINUTE: "1 minute ago",
  DAYS_AGO: "days ago",
  HOURS_AGO: "hours ago",
  MINUTES_AGO: "minutes ago",
  JUST_NOW: "just now",
  NEW: "new"
}


const I18_TRANSLATION_COMMON: I18_TRANSLATION_COMMON_MODEL = {
  COMMON: "common",
};

const MODES: any = {
  EDIT: "edit",
  VIEW: "view",
  CREATE: "create"
};

const NUMBER_CONSTANTS: any = {
  MINUS_ONE: -1,
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
  FIFTEEN:15,
  SIXTEEN: 16,
  TWENTY_FOUR: 24,
  ONE_TWENTY: 120,
  SIXTY: 60,
  NINETY: 90,
  THOUSAND: 1000,
  THOUSAND_TWENTYFOUR: 1024
};

const SESSION_STATUS: any = {
  UPCOMING: "upcoming",
  COMPLETED: "completed",
  CANCELLATION: "cancellation",
  ONGOING: "ongoing"
};

const COMMON_CONSTANTS: any = {
  PDF: "pdf",
  IMAGE: "image",
  UNDER_SCORE: "_",
  DOT: ".",
  PUBLIC_READ: "public-read",
  PLUS: "+",
  HMA_FORMAT: "h:mm A",
  HM_FORMAT: "HH:mm",
  YMD_FORMAT: "YYYY-MM-DD",
  MDY_FORMAT: "MM/DD/YYYY",
  DMY_FORMAT: "DD-MM-YYYY",
  LETTER_T: "T",
  HOUR_MINUTE_SEC: "HH:mm:ss",
  YMD_HSC: "YYYY-MM-DD HH:mm:ss",
  PHONE_FORMAT:"Ex: xxx-xxx-xx"
}

const TEACHING_MODE: any = {
  ONLINE: "online",
  OFFLINE: "offline",
};

/**stepper theme */
const ColorlibConnector = styled(StepConnector)(({ theme }: any) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      //backgroundImage: "linear-gradient(90deg, #8136de 0%, #d670f5 100%)",
      backgroundImage: theme.palette.grey[800],
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // backgroundImage: "linear-gradient(90deg, #8136de 0%, #d670f5 100%)",
      backgroundImage: theme.palette.grey[800],
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  // backgroundColor:
  //  theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  /* ...(ownerState.active && {
    backgroundImage: "linear-gradient(90deg, #8136de 0%, #d670f5 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient(90deg, #8136de 0%, #d670f5 100%)",
  }), */
}));

const ColorlibStepIcon = (props: StepIconProps) => {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    0: <img className="stepper_icons" src={RoundIcon} alt="Learn and Play" />,
    1: (
      <img className="stepper_icons" src={InactiveIcon} alt="Learn and Play" />
    ),
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {active || completed ? icons[String(0)] : icons[String(1)]}
    </ColorlibStepIconRoot>
  );
};

const PDF_CDN_LINK: any = {
  // PDF_JS: "https://unpkg.com/pdfjs-dist@3.8.162/build/pdf.worker.min.js",
  PDF_JS: "https://unpkg.com/pdfjs-dist@3.8.162/build/pdf.worker.min.js",
};

export {
  TOKENS,
  SIDEBAR,
  TOASTER_CONFIGS,
  API_RESPONSE,
  LANGUAGES,
  LOGIN_FIELDS,
  LAYOUTS,
  ADMIN_ROLES,
  ROUTES,
  DASHBOARD,
  ADD_SCHOOLS,
  ADD_UNIVERSITY_FIELDS,
  VALIDATION_CONSTANT,
  AUTHENTICATION_LABELS,
  TUTOR_REGISTRATION_FIELDS,
  TUTOR_TYPE,
  STORAGE_KEYS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  ColorlibStepIcon,
  ColorlibConnector,
  REGISTRATION_FORM,
  PROFESSIONAL_DETAILS,
  PERSONAL_INFORMATION,
  MODES,
  TEACHING_MODE,
  SESSION_STATUS,
  CREATE_SESSIONS_FIELD,
  SESSIONS_ERROR_MESSAGE,
  PDF_CDN_LINK,
  COMMON_CONSTANTS,
  BANKING_INFORMATION,
  PAYLOAD_KEYS,
  DIALOG_CONSTANT,
  TOAST_ERRORS,
  NOTIFICATION_CONSTANTS
};
